export const PROJECT_BY_ID = (id) => `v2/co-op/projects/${id}`;
export const PROJECTS = `v2/co-op/projects`;
export const IORGANISATIONS_MEMBERSHIPS_BY_ID = (id) => `v2/I-organisations-memberships/${id}`;